import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {ReactComponent as GoogleIcon} from '../../../../assets/icons/google.svg';
import {ReactComponent as OkIcon} from '../../../../assets/icons/ok_green.svg';
// import {ReactComponent as FaceBookIcon} from '../../../../assets/icons/facebook.svg';
// import {ReactComponent as AppleIcon} from '../../../../assets/icons/apple.svg';
import './Social.scss';
import {useDispatch, useSelector} from 'react-redux';
import {postSignInSocial} from '../../../../redux/actions/auth/authActions';
import {getProfileMe, socialsProviderDelete} from '../../../../redux/actions/profile/profileActions';
import {notifySuccess} from '../../../../helpers/notifySnack';

const Social = () => {
  const {profileMe} = useSelector((state) => state.profile);

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const {t} = useTranslation();

  const findFacebookProvider = profileMe?.socials?.find((el) => el.provider === 'facebook');
  const googleProvider = profileMe?.socials?.find((el) => el.provider === 'google');

  const onAuthSocial = async (provider) => {
    setLoading(true);
    if (loading) return;
    if (provider === 'facebook' && findFacebookProvider) {
      return dispatch(socialsProviderDelete(provider)).then((res) => {
        if (res.payload) {
          dispatch(getProfileMe());
          notifySuccess(t('all.successfully'));
        }
        setLoading(false);
      });
    }
    if (provider === 'google' && googleProvider) {
      return dispatch(socialsProviderDelete(provider)).then((res) => {
        if (res.payload) {
          dispatch(getProfileMe());
          notifySuccess(t('all.successfully'));
        }
        setLoading(false);
      });
    }
    await dispatch(postSignInSocial(provider)).then((res) => {
      if (!res.payload) {
        return;
      }
      setLoading(false);
      window.location.href = res.payload.data.url;
    });
  };

  return (
    <div className='user-social'>
      <div className='user-social-title'>{t('Social.syncServicesTitle')}</div>
      <div
        className={`social-button${googleProvider ? ' active' : ''}`}
        onClick={() => {
          onAuthSocial('google');
        }}
      >
        <div className='info'>
          <div className='social-icon'>
            <GoogleIcon />
          </div>
          <div className='text visible'>{t('Social.googleAccount')}</div>
          <div className='text hidden'>{t('Social.disconnectGoogle')}</div>
        </div>
        <div className='icon'>
          <OkIcon />
        </div>
      </div>
      {/*<div*/}
      {/*  className={`social-button${findFacebookProvider ? ' active' : ''}`}*/}
      {/*  onClick={() => {*/}
      {/*    onAuthSocial('facebook');*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <div className='info'>*/}
      {/*    <div className='social-icon'>*/}
      {/*      <FaceBookIcon />*/}
      {/*    </div>*/}
      {/*    <div className='text visible'>{t('Social.facebookAccount')}</div>*/}
      {/*    <div className='text hidden'>{t('Social.disconnectFacebook')}</div>*/}
      {/*  </div>*/}
      {/*  <div className='icon'>*/}
      {/*    <OkIcon />*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  );
};

export default Social;
